<template>
  <div class="general">
    <div
      v-if="tipStatus"
      class="tip"
      :style="{
        top: `${top}px`,
        left: `${left}px`,
      }"
    >
      <span class="translate">Dernière mise à jour :</span>
      {{ formatDayjsDateAndHours(getDayjsDate(tipDate)) }}
      <br />
      <span class="translate">Statut :</span> {{ tipStatus }}
    </div>
    <div
      v-if="bubbleShown"
      class="speech-bubble text-gray translare"
      :style="{
        top: bubbleTop + 'px',
        left: bubbleLeft + 5 + 'px',
      }"
    >
      {{ bubbleTitle }}
    </div>
    <div
      v-if="banksShown && showConfig"
      class="my-banks"
    >
      <FontAwesomeIcon
        class="close-btn clickable"
        icon="times"
        @mousedown="showConfig = false"
      />
      <BankConfig
        :bank="showConfig"
        @remove="onBankRemoveClick($event)"
      />
    </div>
    <div
      v-else-if="banksShown"
      class="my-banks"
    >
      <div
        v-if="showSubmenu"
        v-click-outside="vsoConfig"
        class="fy-m-submenu"
        :style="showSubmenu"
      >
        <template v-if="showSubmenu?.type === 'treasury_wallet'">
          <div
            class="fy-m-submenu-item clickable translate"
            @click="
              $router.push({name: 'my-investments'});
              showSubmenu = null;
            "
          >
            Gérer les placements
          </div>
          <div
            class="fy-m-submenu-item clickable translate"
            @click="
              $router.push({name: 'treasury-investment-profile'});
              showSubmenu = null;
            "
          >
            Mettre à jour le profil investisseur
          </div>
        </template>
        <template v-else>
          <div
            class="fy-m-submenu-item clickable translate"
            @click="
              modifyConnection(showSubmenu);
              showSubmenu = null;
            "
          >
            Mettre à jour la connexion
          </div>

          <div
            class="fy-m-submenu-item clickable translate"
            @click="
              showConfig = showSubmenu;
              showSubmenu = null;
            "
          >
            Paramétrer l’affichage des comptes
          </div>
        </template>
      </div>
      <FontAwesomeIcon
        class="close-btn clickable"
        icon="times"
        @mousedown="closeBanks"
      />
      <div class="text-upper banks-title translate">
        <i class="fi-cb" />
        Mes banques
      </div>
      <div
        v-if="banks && banks.length"
        class="banks-list"
      >
        <div
          v-for="b in banks"
          :key="`me-bank-${b.id}`"
          class="bank"
        >
          <div
            :key="`me-info-${b.id}`"
            class="account"
          >
            <div
              class="bank-logo not-translate"
              :style="{
                'background-color': stringToHslColor(b.name, 50, 60),
              }"
            >
              {{ nameToSlug(b.name) }}
            </div>
            <div class="names">
              <div class="bank-name not-translate">
                {{ b.custom_name || b.name }}
              </div>
              <div
                class="account-name text-small"
                :class="{
                  err: b.state.status === 'error',
                  warn: b.state.status === 'warning',
                  act: b.state.status === 'working',
                }"
              >
                {{ b.state.fygr_short_message }}
              </div>
              <div
                v-if="b.last_update"
                class="text-gray"
              >
                <span class="translate"> Dernière synchronisation : </span>
                <span class="not-translate">
                  {{ formatDayjsDateAndHours(getDayjsDate(b.last_update)) }}
                </span>
              </div>
            </div>
            <div class="controls">
              <div
                v-if="b.type !== 'treasury_wallet'"
                class="btn red clickable"
                @click="() => onBankRemoveClick(b.id)"
              >
                <i class="fi-delete" />
              </div>
              <div
                class="btn blue clickable"
                @click="onSettingsClick($event, b)"
                @mouseenter="
                  (e) =>
                    showTip(e, true, b.state.fygr_description, b.last_update)
                "
                @mouseleave="(e) => showTip(e, false)"
              >
                <FontAwesomeIcon
                  v-if="b.state.status === 'error'"
                  icon="circle"
                  class="attention-dot"
                  style="pointer-events: none"
                />
                <i
                  class="fi-settings"
                  style="pointer-events: none"
                />
              </div>
            </div>
          </div>
          <div
            v-for="a in b.accounts"
            :key="`me-acc-${a.id}`"
            class="account"
          >
            <div class="bank-logo">
              <div
                class="fy-m-pin"
                :class="{'fy-m-pin-green': a.pinned}"
                @click.stop="pinAccounts(b.id, [a.id], !a.pinned)"
                @mouseenter="
                  (e) =>
                    showBubble(
                      e,
                      true,
                      a.pinned ? 'Retirer l\'épingle' : 'Épingler',
                      41,
                      a.pinned ? -35 : -13,
                    )
                "
                @mouseleave="(e) => showBubble(e, false)"
              >
                <i class="fi-pin" />
              </div>
            </div>
            <div class="names">
              <div
                :title="b.custom_name || b.name"
                class="bank-name shorten not-translate"
                :style="`width: calc(100% - ${
                  formatCurrency(a.balance, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    currency: a.currency,
                  }).length * 8.5
                }px);`"
              >
                {{ b.custom_name || b.name }}
              </div>
              <div class="account-name text-gray">
                <div
                  :title="a.custom_name || a.name"
                  :class="
                    a.pending_transfers && a.pending_transfers !== 0
                      ? 'acc-label-short'
                      : ''
                  "
                >
                  {{ a.custom_name || a.name }}
                </div>
                <div class="in-process">
                  <span
                    v-if="a.pending_transfers && a.pending_transfers !== 0"
                    class="coming-title translate"
                  >
                    En cours :
                  </span>
                  <span
                    v-if="a.pending_transfers && a.pending_transfers !== 0"
                    class="coming-balance not-translate"
                    :class="{
                      'text-red': a.pending_transfers < 0,
                      'text-green': a.pending_transfers > 0,
                    }"
                  >
                    {{
                      formatCurrency(a.pending_transfers, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        currency: a.currency,
                      })
                    }}</span
                  >
                  <div
                    v-if="a.pending_transfers && a.pending_transfers !== 0"
                    class="preview-pending"
                    @click.stop="showOngoingTransfers(a.id)"
                  >
                    <span class="counter">
                      {{
                        a.pending_transfers_count > 9
                          ? '9+'
                          : a.pending_transfers_count
                      }}
                    </span>
                    <FontAwesomeIcon icon="eye" />
                  </div>

                  <div class="balance">
                    <span>{{
                      formatCurrency(a.balance, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        currency: a.currency,
                      })
                    }}</span>
                    <div
                      v-if="a.pending_transfers && a.pending_transfers !== 0"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="separator" />
        </div>
      </div>
      <div
        v-else
        class="banks-list text-gray"
      >
        <LuPlaceholder> Aucune banque connectée pour le moment </LuPlaceholder>
      </div>
      <a
        v-if="
          subscription.has_subscription ||
          subscription.trial ||
          subscription.default
        "
        class="add-bank clickable text-blue translate"
        @click="goToDashboardAndAddBank"
      >
        <FontAwesomeIcon
          icon="plus"
          class="clickable"
        />
        Ajouter une banque
      </a>
    </div>
    <div
      v-else-if="companiesShown"
      class="my-banks"
    >
      <FontAwesomeIcon
        class="close-btn clickable"
        icon="times"
        @mousedown="closeCompanies"
      />
      <div class="text-upper banks-title translate">
        <FontAwesomeIcon icon="city" />
        Mes entreprises
      </div>
      <div
        v-if="Object.entries(companies).length"
        class="banks-list"
      >
        <div
          v-for="c in displayedCompanies(companies)"
          :key="`me-c-${c[0]}`"
          class="bank"
        >
          <div class="account">
            <div
              class="bank-logo not-translate"
              :style="{
                'background-color': stringToHslColor(c[1][0], 50, 60),
              }"
            >
              {{ nameToSlug(c[1][0]) }}
            </div>
            <div class="names">
              <div class="bank-name not-translate">
                {{ c[1][0] }}
              </div>
            </div>
            <div class="controls">
              <div
                v-if="c[1][4]"
                v-show="checkRole(user, admin_gr)"
                class="btn red clickable"
                @click="() => onCompanyRemoveClick(c[0])"
              >
                <i class="fi-delete" />
              </div>
              <div
                class="btn blue clickable"
                @click="openCompany(c[0], c[1][3])"
              >
                <i class="fi-settings" />
              </div>
            </div>
          </div>
          <div class="separator" />
        </div>
      </div>
      <div
        v-else
        class="banks-list text-gray"
      >
        <LuPlaceholder> Aucune entreprises pour le moment </LuPlaceholder>
      </div>
      <a
        v-if="!isCpaUser(activeUser) || permissions.cpap_create_managed_company"
        class="add-bank clickable text-blue translate"
        @click="$emit('createCompany')"
      >
        <FontAwesomeIcon
          icon="plus"
          class="clickable"
        />
        {{
          isCpaUser(activeUser)
            ? 'Ajouter un dossier'
            : 'Ajouter une entreprise'
        }}
      </a>
    </div>
    <div
      v-else-if="showPartnerIntegrations"
      class="my-integrations"
    >
      <FontAwesomeIcon
        class="close-btn clickable"
        icon="times"
        @mousedown="showPartnerIntegrations = false"
      />
      <div class="text-center partner-integration-title text-upper translate">
        Gérer les intégrations
      </div>
      <div
        v-if="partnersIntegrations && partnersIntegrations.length > 0"
        class="partner-integration-list"
      >
        <div
          v-for="partnerIntegration in partnersIntegrations"
          :key="partnerIntegration.partner_id"
          class="partner-block"
        >
          <div class="account">
            <div class="names">
              <div class="partner-integration-name not-translate">
                {{ partnerIntegration.partner_name }}
              </div>
              <p
                v-if="partnerIntegration.status === 'active'"
                class="integration-status-active translate"
              >
                Connexion active
              </p>
              <p
                v-else
                class="integration-status-error translate"
              >
                Erreur de connexion
              </p>
              <p class="last-synced text-gray">
                <span class="translate">Dernière synchronisation: </span>
                <span
                  v-if="partnerIntegration.last_synced"
                  class="not-translate"
                >
                  {{
                    formatDayjsDateAndHours(
                      getDayjsDate(partnerIntegration.last_synced),
                    )
                  }}
                </span>
                <span
                  v-else
                  class="translate"
                  >Erreur</span
                >
              </p>
            </div>
            <div class="controls">
              <div
                class="btn red clickable"
                @click.stop="
                  onPartnerIntegrationRemoveClick(partnerIntegration);
                  integrationToDelete = partnerIntegration;
                "
              >
                <i class="fi-delete" />
              </div>
              <div
                class="btn blue clickable"
                @mouseenter="displayBubble(partnerIntegration.partner_id)"
                @mouseleave="bubbleShown = null"
                @click="editPartnerIntegration(partnerIntegration)"
              >
                <i class="fi-settings" />
                <span
                  v-if="bubbleShown === partnerIntegration.partner_id"
                  class="integration-settings-info"
                />
              </div>
            </div>
          </div>
          <div class="separator" />
        </div>
      </div>
      <div
        v-else
        class="partner-integration-list text-gray"
      >
        <LuPlaceholder>
          Aucune intégration paramétrée pour le moment
        </LuPlaceholder>
      </div>
      <a
        class="add-partner-integration clickable text-blue translate"
        @click="addNewPartnerIntegration"
      >
        <FontAwesomeIcon
          icon="plus"
          class="clickable"
        />
        <span>Ajouter une intégration </span>
      </a>
    </div>
    <div
      v-else
      class="initial-menu translate"
    >
      <div
        v-show="checkRole(user, sales_gr)"
        class="menu-item clickable"
        @click="openAdmin"
      >
        <i class="fi-settings text-gray" />
        <span>Admin</span>
      </div>
      <div
        v-if="user && user.role === 'SuperAdmin'"
        class="divider"
      />
      <div
        class="menu-item clickable"
        @click="openProfile"
      >
        <i class="fi-people text-gray" />
        <span> Mon profil</span>
      </div>
      <div class="divider" />
      <template v-if="permissions.bank_management">
        <div
          class="menu-item clickable"
          @mousedown="showBanks"
        >
          <i class="fi-cb text-gray" />
          <span
            >Mes banques
            <FontAwesomeIcon
              v-if="hasBanksErrors"
              icon="circle"
              class="alarm-dot"
          /></span>
        </div>
        <div class="divider" />
      </template>
      <template v-if="isActiveForCurrentCompany && !isCompanyCpa">
        <div
          class="menu-item clickable"
          @click="openUsers"
        >
          <div class="user-logo">
            <i class="fi-people text-gray" />
            <i class="fi-people text-gray" />
          </div>
          <span> Mes utilisateurs</span>
        </div>
        <div class="divider" />
      </template>
      <div
        class="menu-item clickable"
        @click="openMyCompany"
      >
        <FontAwesomeIcon
          class="city"
          icon="city"
        />
        <span> Mon entreprise</span>
      </div>
      <div class="divider" />
      <div
        class="menu-item clickable"
        @mousedown="$emit('showFunding')"
      >
        <i class="fi-financement" />
        <span>Financement</span>
      </div>
      <template
        v-if="
          (treasuryInvestmentEnabled && banks && banks.length) || isDemoAccount
        "
      >
        <div class="divider" />
        <div
          class="menu-item clickable treasury"
          @mousedown="treasuryClicked('UserMenu')"
        >
          <i class="fi-rocket-launch" />
          <span>Placement de trésorerie</span>
        </div>
      </template>
      <div class="divider" />
      <template v-if="gsheet">
        <a
          class="menu-item clickable"
          target="_blank"
          :href="gsheet"
        >
          <FontAwesomeIcon
            class="sheet"
            icon="sheet-plastic"
          />
          <span>Ma Google Sheet</span>
        </a>
        <div class="divider" />
      </template>
      <template v-if="isActiveForCurrentCompany && !isCompanyCpa">
        <div
          class="menu-item clickable"
          @click="showIntegrationsPopup"
        >
          <i class="fi-integration" />
          <span>Mes intégrations</span>
        </div>
        <div class="divider" />
      </template>
      <template v-if="false && getLocale === 'fr'">
        <div
          class="menu-item clickable"
          @click="showSponsorshipProgram()"
        >
          <a>
            <FontAwesomeIcon
              class="gift"
              icon="gift"
            />
            <span> Parrainage</span>
          </a>
        </div>
        <div class="divider" />
      </template>
      <div
        class="menu-item clickable red"
        @mousedown="actionLogout"
      >
        <i class="fi-logout" />
        <span>Déconnexion</span>
      </div>
    </div>
    <TransfersInProgressPopup
      v-if="ongoingTransfersAccountId"
      :account-id="ongoingTransfersAccountId"
      @close="ongoingTransfersAccountId = null"
    />
    <TreasuryIntroPopup
      v-if="showTreasuryIntroPopup"
      @close="showTreasuryIntroPopup = false"
      @invest="
        $router.push({
          name: 'treasury-investment',
        })
      "
      @investmnets="
        $router.push({
          name: 'my-investments',
        })
      "
    />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import {companyMixin} from '@/mixins/companyMixin';
import {cpaMixin} from '@/mixins/cpaMixin';
import {formatMixin} from '@/mixins/formatMixin';
import {rolesChecker} from '@/mixins/rolemixin';
import {datesMixin} from '@/mixins/datesMixin';
import {treasuryPopupMixin} from '@/mixins/treasuryPopupMixin';
import roles from '@/data/roles/index';
import jwtDecode from 'jwt-decode';
import vClickOutside from 'click-outside-vue3';
import BankConfig from '@/components/widgets/BankConfig.vue';
import en from '@/data/tracking';
import {defineAsyncComponent} from 'vue';

export default {
  name: 'UserMenu',
  components: {
    BankConfig,
    TreasuryIntroPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/TreasuryIntroPopup.vue'),
    ),
    TransfersInProgressPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/TransfersInProgressPopup.vue'),
    ),
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mixins: [
    companyMixin,
    cpaMixin,
    rolesChecker,
    formatMixin,
    datesMixin,
    treasuryPopupMixin,
  ],
  emits: [
    'createCompany',
    'showFunding',
    'close',
    'showAddBankPopup',
    'showConfirmDeletePartnerIntegration',
    'showConfirmDeleteBank',
    'showConfirmDeleteCompany',
  ],
  data() {
    return {
      banksShown: false,
      companiesShown: false,
      showPartnerIntegrations: false,
      tipDate: null,
      tipStatus: null,
      timeout: null,
      top: 0,
      left: 0,
      sales_gr: roles.SALES_GROUP_ROLE,
      admin_gr: roles.ADMIN_GROUP_ROLE,
      partnersIntegrations: [],
      bubbleLeft: 0,
      bubbleShown: false,
      bubbleTitle: '',
      bubbleTop: 0,
      showDeleteIntegration: false,
      integrationToDelete: null,
      showSubmenu: null,
      showConfig: null,
      ongoingTransfersAccountId: null,
      vsoConfig: {
        handler: () => {
          this.showSubmenu = false;
        },
        events: ['mousedown'],
      },
    };
  },

  computed: {
    ...mapGetters('user', ['activeUser', 'getLocale', 'isDemoAccount']),
    ...mapState('app', ['categories', 'scaleRatio']),
    ...mapState('user', ['user']),
    ...mapState('bank', ['banks']),
    ...mapState('partner', ['partnerIntegrations']),
    ...mapState('subscription', ['subscription']),

    ...mapState('user', [
      'params',
      'user',
      'profileData',
      'owner',
      'companies',
      'permissions',
      'isActiveForCurrentCompany',
      'isCompanyCpa',
      'selectedCompany',
      'gsheet',
    ]),

    hasBanksErrors() {
      const banks = this.banks
        ? this.banks.map((b) => b.state.status === 'error')
        : [true];
      return banks.includes(true);
    },
  },

  async mounted() {
    const token = jwtDecode(localStorage.getItem('FYGR_ACCESS_TOKEN'));
    if (token.role === 'CpaRole') {
      await this.actionGetPartnerIntegrations(token.identity);
    }
    const companyId = localStorage.getItem('FYGR_COMPANY');
    await this.actionGetPartnerIntegrations(companyId);
    if (this.partnerIntegrations.error === false) {
      this.partnersIntegrations = this.partnerIntegrations?.result;
    }
  },
  methods: {
    ...mapActions('user', ['actionLogout']),
    ...mapActions('bank', ['actionGetModifyUrl', 'actionPinAccounts']),
    ...mapActions('partner', [
      'actionDeletePartnerIntegration',
      'actionSelectCurrentPartner',
      'actionGetPartnerIntegrations',
    ]),
    ...mapActions('app', ['actionSetSelectedCompany']),
    ...mapActions('tracking', ['actionUpdateHubSpotObject']),
    async showOngoingTransfers(accountId) {
      this.ongoingTransfersAccountId = accountId;
    },
    pinAccounts(bankId, accountIds, pinned) {
      this.actionPinAccounts({
        bank_id: bankId,
        account_ids: accountIds,
        pinned,
      });
    },
    showBubble(e, show, title, fixY, fixX) {
      this.bubbleTitle = title;
      this.bubbleTop = e.clientY - e.offsetY + 5 - fixY / this.scaleRatio; //TODO share this version to mixin
      this.bubbleLeft = e.clientX - e.offsetX - 15 + fixX / this.scaleRatio;
      this.bubbleShown = show;
    },
    showTip(e, display, desc, date) {
      if (display) {
        this.top = e.clientY - e.offsetY + 25 / this.scaleRatio;
        this.left = e.clientX - e.offsetX - 325 / this.scaleRatio;
        this.tipDate = date;
        this.tipStatus = desc;
      } else {
        this.tipDate = null;
        this.tipStatus = null;
      }
    },
    openProfile() {
      this.$emit('close');
      this.$router.push('/profile');
    },
    openUsers() {
      this.$emit('close');
      this.$router.push('/users');
    },
    openMyCompany() {
      this.$emit('close');
      this.$router.push('/company');
    },
    openAnalytics() {
      this.$emit('close');
      this.$router.push('/analytics');
    },
    openAdmin() {
      this.$emit('close');
      this.$router.push('/admin');
    },
    goToDashboardAndAddBank() {
      this.$emit('close');
      this.$emit('showAddBankPopup');
    },
    logout() {
      this.actionLogout();
    },
    showBanks() {
      this.banksShown = true;
    },
    closeBanks() {
      this.banksShown = false;
    },
    addBank() {
      return true;
    },
    onPartnerIntegrationRemoveClick(partnerIntegration) {
      this.$emit('showConfirmDeletePartnerIntegration', partnerIntegration);
    },
    onBankRemoveClick(id) {
      this.$emit('showConfirmDeleteBank', id);
    },
    onCompanyRemoveClick(id) {
      this.$emit('showConfirmDeleteCompany', id);
    },
    onSettingsClick(e, b) {
      const t = e.y - e.offsetY + e.target.offsetHeight + 5 / this.scaleRatio;
      const l = e.x - e.offsetX + e.target.offsetWidth - 295 / this.scaleRatio;
      this.showSubmenu = {...b, top: `${t}px`, left: `${l}px`};
    },
    modifyConnection(b) {
      this.actionUpdateHubSpotObject({
        HSObj: {
          type: 'deal',
          properties: {
            update_bank_connection_attempt: JSON.stringify({
              bank_name: b.name,
              connector_name: b.aggregator,
              state: b.state,
              last_update: b.last_update,
              attempt_date: Date(),
            }),
          },
        },
      });
      window.analytics.track(en.EN_USER_REDIRECTED_TO_AIS_PROVIDER.name, {
        ...en.EN_USER_REDIRECTED_TO_AIS_PROVIDER.properties,
        email: this.user.email,
        ais_provider: b.aggregator,
        bank_name: b.name,
        action: 'update',
      });
      this.actionGetModifyUrl(b.id);
    },
    showIntegrationsPopup() {
      this.showPartnerIntegrations = true;
    },
    showSponsorshipProgram() {
      return true;
    },
    displayBubble(id) {
      this.bubbleShown = id;
    },
    addNewPartnerIntegration() {
      // this.$router.push('/myunisoft-integration');
      window.analytics.track(
        en.EN_ADD_PARTNER_INTEGRATION_BUTTON_CLICKED.name,
        {
          ...en.EN_ADD_PARTNER_INTEGRATION_BUTTON_CLICKED.properties,
          email: this.user.email,
        },
      );
      this.$router.push('/partner/selection');
    },
    editPartnerIntegration(partner) {
      this.$router.push({
        name: 'partner-selection',
        query: {
          partner_id: partner.partner_id,
          partner_integration_id: partner.partner_integration_id,
        },
      });
    },
    async deleteIntegration() {
      this.deletingIntegration = true;
      await this.actionDeletePartnerIntegration({
        partner_id: this.integrationToDelete.partner_id,
        partner_integration_id: this.integrationToDelete.partner_integration_id,
      });
      this.deletingIntegration = false;
      this.showDeleteIntegration = false;
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'sass:color';

.add-partner-integration {
  align-self: flex-start;
  margin-top: var(--px20);
  @extend %text-font-demibold;
  &:hover {
    color: color.adjust($blue, $lightness: 15%);
  }
  svg {
    margin-right: var(--px10);
  }
}
.fy-m-pin {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: var(--px3);
  width: var(--px30);
  height: var(--px30);
  border-radius: var(--px8);
  background-color: rgba($gray, 0.1);
  color: $gray;
  cursor: pointer;
  user-select: none;
  &.balance {
    cursor: auto;
    &:hover {
      filter: brightness(1);
    }
  }
  &:hover {
    filter: brightness(0.8);
  }
  &.fy-m-pin-green {
    background-color: rgba($green, 0.1);
    color: $green;
  }
  i {
    margin-top: var(--px2);
  }
}
.user-logo {
  display: flex;
  margin-right: var(--px10);
  .fi-people {
    font-size: var(--px10);
    margin-right: 0;
    &:last-child {
      margin: 0;
      margin-right: 1px;
    }
  }
}
.divider {
  width: 100%;
  background-color: rgba($gray, 0.5);
  height: 1px;
}
.initial-menu {
  width: var(--px220);
  display: flex;
  flex-direction: column;
}
.container[class] {
  background-color: white;
  border-radius: var(--px10);
  padding: var(--px20);
  margin: var(--px10);
}
.menu-item {
  position: relative;
  display: flex;
  user-select: none;
  align-items: center;
  min-height: var(--px44);
  font-size: var(--px14);
  color: $text-color-gray;
  &:hover {
    background-color: $hover;
    color: $text-color-gray;
    border-radius: var(--px5);
  }
  .alarm-dot[class] {
    color: $red;
    font-size: var(--px5);
    margin: 0 0 var(--px8) var(--px2);
  }
  span {
    position: absolute;
    left: var(--px30);
  }
  img {
    height: var(--px20);
  }
  i {
    font-size: var(--px16);
    &.fi-financement {
      font-size: var(--px14);
    }
    &.fi-rocket-launch {
      font-size: var(--px20);
    }
  }
  svg {
    &:not(.city) {
      font-size: var(--px10);
    }
    &.gift {
      font-size: var(--px14);
    }
    &.sheet {
      font-size: var(--px17);
    }
    //&.chart {
    //  font-size: var(--px16);
    //  margin-right: var(--px12);
    //}
    color: $text-color-gray;
  }
}
.red {
  color: $red;
  &:hover {
    color: color.adjust($red, $lightness: 10%);
  }
}
.my-banks[class] {
  width: var(--px450);
  padding: var(--px10);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: var(--px14);
  .banks-list[class] {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: var(--px25);
    max-height: var(--px300);
    overflow: auto;
    font-size: var(--px14);
    &.text-gray[class] {
      font-size: var(--px14);
      img {
        height: var(--px50);
        width: var(--px120);
        margin: 0 auto;
        margin-bottom: var(--px10);
      }
    }
    .bank[class] {
      display: flex;
      flex-direction: column;
      width: 100%;
      font-size: var(--px14);
      .account[class] {
        font-size: var(--px14);
        display: flex;
        &:not(:first-child) {
          margin-top: var(--px20);
        }
        .bank-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          width: var(--px40);
          height: var(--px40);
          color: white;
          text-transform: uppercase;
          border-radius: 50%;
          margin-right: var(--px20);
          user-select: none;
        }
        .names {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          flex: 1;
          .shorten {
            text-align: start;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .account-name[class] {
            display: flex;
            justify-content: space-between;
            width: 100%;
            font-size: var(--px14);
            position: relative;
            .acc-label-short {
              width: 56%;
              max-width: var(--px220);
              white-space: nowrap;
              text-overflow: ellipsis;
              word-wrap: break-word;
              overflow: hidden;
              display: block;
              text-align: start;
            }
            .in-process {
              width: 44%;
            }
            div {
              text-align: end;
              display: flex;
              justify-content: space-between;
            }
            .coming-title {
              font-size: var(--px12);
              line-height: var(--px20);
            }
            .preview-pending {
              z-index: 3;
              position: relative;
              width: 28px;
              display: inline-flex;
              align-items: center;
              color: $gray;
              cursor: pointer;
              &:hover {
                color: $blue;
              }
              .counter {
                position: absolute;
                top: -1px;
                right: 1px;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: 10px;
                width: 12px;
                text-align: left;
              }
              i {
              }
            }
            .coming-balance {
              font-size: var(--px12);
              line-height: var(--px20);
              margin-right: var(--px5);
            }
            .balance {
              margin-right: var(--px5);
              position: absolute;
              bottom: var(--px-2);
              right: 0;
              flex-direction: column;
              display: flex;

              div {
                height: var(--px21);
              }
            }
          }
          .integration-status-active,
          .integration-status-error,
          .last-synced {
            margin: 0;
            @extend %text-font-small;
          }
          .integration-status-active {
            color: $green;
          }
          .integration-status-error {
            color: $red;
          }
        }
        .controls {
          display: flex;
          justify-content: center;
          flex: 0;
          margin-top: var(--px2);
          margin-right: var(--px5);
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: var(--px25);
            height: var(--px25);
            border-radius: var(--px5);
            &:last-child {
              margin-left: 10px;
            }
            &.red {
              color: $red;
              background-color: rgba($red, 0.15);
              &:hover {
                background-color: rgba($red, 0.25);
              }
            }
            &.blue {
              color: $blue;
              background-color: rgba($blue, 0.15);
              &:hover {
                background-color: rgba($blue, 0.25);
              }
            }
            .attention-dot[class] {
              position: absolute;
              top: -2px;
              right: -2px;
              color: $red;
              font-size: var(--px5);
            }
          }
        }
      }
      .separator {
        height: 1px;
        background-color: $bg;
        margin: var(--px20) 0;
      }
    }
  }
  .add-bank {
    align-self: flex-start;
    margin-top: var(--px20);
    font-size: var(--px14);
    &:hover {
      color: color.adjust($blue, $lightness: 15%);
    }
    svg {
      margin-right: var(--px15);
    }
  }
  .banks-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--px14);
    i {
      margin-right: var(--px10);
      color: $gray;
    }
    svg {
      margin-right: var(--px10);
      color: $gray;
    }
  }
  .close-btn {
    color: $gray;
    position: absolute;
    top: var(--px20);
    right: var(--px20);
    &:hover {
      color: color.adjust($gray, $lightness: -10%);
    }
  }
}
.my-integrations[class] {
  width: var(--px450);
  padding: var(--px10);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: var(--px14);
  .partner-integration-list[class] {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: var(--px25);
    max-height: var(--px300);
    overflow: auto;
    font-size: var(--px14);
    &.text-gray[class] {
      font-size: var(--px14);
      img {
        height: var(--px50);
        width: var(--px120);
        margin: 0 auto;
        margin-bottom: var(--px10);
      }
    }
    .partner-block[class] {
      display: flex;
      flex-direction: column;
      width: 100%;
      font-size: var(--px14);
      .account[class] {
        font-size: var(--px14);
        display: flex;
        &:not(:first-child) {
          margin-top: var(--px20);
        }
        .names {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          flex: 1;
          .partner-integration-name[class] {
            text-transform: capitalize;
            display: flex;
            justify-content: space-between;
            width: 100%;
            font-size: var(--px14);
          }
          .integration-status-active,
          .integration-status-error,
          .last-synced {
            margin: 0;
            @extend %text-font-small;
          }
          .integration-status-active {
            color: $green;
          }
          .integration-status-error {
            color: $red;
          }
        }
        .controls {
          display: flex;
          justify-content: center;
          flex: 0;
          margin-top: var(--px2);
          margin-right: var(--px5);
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: var(--px25);
            height: var(--px25);
            border-radius: var(--px5);
            &:last-child {
              margin-left: 10px;
            }
            &.red {
              color: $red;
              background-color: rgba($red, 0.15);
              &:hover {
                background-color: rgba($red, 0.25);
              }
            }
            &.blue {
              color: $blue;
              background-color: rgba($blue, 0.15);
              &:hover {
                background-color: rgba($blue, 0.25);
              }
            }
            .attention-dot[class] {
              position: absolute;
              top: -2px;
              right: -2px;
              color: $red;
              font-size: var(--px5);
            }
          }
        }
      }
      .separator {
        height: 1px;
        background-color: $bg;
        margin: var(--px20) 0;
      }
    }
  }
  .add-partner-integration {
    align-self: flex-start;
    margin-top: var(--px20);
    font-size: var(--px14);
    &:hover {
      color: color.adjust($blue, $lightness: 15%);
    }
    svg {
      margin-right: var(--px10);
    }
  }
  .partner-integration-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--px14);
    i {
      margin-right: var(--px10);
      color: $gray;
    }
    svg {
      margin-right: var(--px10);
      color: $gray;
    }
  }
  .close-btn {
    color: $gray;
    position: absolute;
    top: var(--px20);
    right: var(--px20);
    &:hover {
      color: color.adjust($gray, $lightness: -10%);
    }
  }
}
div {
  transition: width 100ms linear;
}
i {
  display: flex;
  align-items: center;
  justify-content: center;
}
.err {
  color: $red;
}
.warn {
  color: $chart-color-1;
}
.act {
  color: $green;
}
.general {
  position: relative;
  .tip {
    color: white;
    background-color: rgba($ebony, 0.8);
    position: fixed;
    padding: var(--px15);
    border-radius: var(--px10);
    width: var(--px300);
  }
  .fy-m-submenu {
    display: flex;
    flex-direction: column;
    position: fixed;
    width: var(--px295);
    height: var(--px60);
    padding: var(--px10) 0;
    background: #ffffff;
    box-shadow: 0 0 var(--px10) rgba(0, 0, 0, 0.15);
    border-radius: var(--px8);
    z-index: 5;
    text-align: left;
    .fy-m-submenu-item {
      padding: var(--px5) var(--px20);
      &:hover {
        background-color: $blue;
        color: white;
      }
    }
  }
}
</style>
